export default "__VITE_ASSET__BMHSozei__"